import * as types from "./types";
import {
    postUploadBankStatementAxios,
    getUploadBankStatementAxios,
    getUploadBankStatementByIdAxios,
    updateUploadBankStatementAxios
} from "./services";

export async function postUploadBankStatementAction({ commit }, payload) {
    commit(types.LOADING_BANKSTATEMENT, true);
    try {
        // await postLeaveRequestAxios(payload);
        // commit(types.ADD_LEAVEREQUEST, payload);
        const { data } = await postUploadBankStatementAxios(payload);
        (payload);
        commit(types.POST_BANKSTATEMENT, payload);
        return data;
    }
    catch (e) {
        throw e;
    }
    finally {
        commit(types.LOADING_BANKSTATEMENT, false);
    }
}

export async function getUploadBankStatementAction({commit}, BankId) {
    commit(types.LOADING_BANKSTATEMENT, true);
    try {
        const {data} = await getUploadBankStatementAxios(BankId);
        commit(types.GET_BANKSTATEMENT, data.result);
        return data.result;
    }
    catch(e) {
        throw e;
    }
    finally {
        commit(types.LOADING_BANKSTATEMENT, false);
    }
   
}

export async function getUploadBankStatementByIdAction({commit}, statementID) {
    commit(types.LOADING_BANKSTATEMENT, true);
    try {
        const {data} = await getUploadBankStatementByIdAxios(statementID);
        commit(types.GET_BANKSTATEMENT_BY_ID, data.result);
        return data;
    }
    catch(e) {
        throw e;
    }
    finally {
        commit(types.LOADING_BANKSTATEMENT, false);
    }
}


export async function putUploadBankStatementByIdAction({commit}, payload) {
    commit(types.LOADING_BANKSTATEMENT, true);
    try {
        const {data} = await updateUploadBankStatementAxios(payload);
        commit(types.UPDATE_BANKSTATEMENT, data.result);
        return data;
    }
    catch(e) {
        throw e;
    }
    finally {
        commit(types.LOADING_BANKSTATEMENT, false);
    }
}